// 导入 createAPI 模块
import { createAPI } from 'cube-ui'
// 导入Vue
import Vue from 'vue'
// 导入需要注册的组件
import HsPicker from 'base/hs-picker/hs-picker'

/** 创建全局hsPicker组件 */
createAPI(Vue, HsPicker)
